import { cn } from '@undp/design-system-react/cn';
import { P } from '@undp/design-system-react/Typography';

import { numberFormattingFunction } from '@/Utils/numberFormattingFunction';

interface Props {
  colors: string[];
  colorDomain: number[];
  colorLegendTitle?: string;
  width?: number;
  className?: string;
  locale?: string;
}

export function LinearColorLegend(props: Props) {
  const { colorLegendTitle, colorDomain, colors, width, className, locale = 'en' } = props;
  return (
    <div
      className={cn('flex gap-0 flex-wrap justify-center leading-0 pb-3', className)}
      style={{ maxWidth: width ? `${width}px` : 'none' }}
    >
      {colorLegendTitle && colorLegendTitle !== '' ? (
        <P size='sm' marginBottom='2xs' className='w-full text-center'>
          {colorLegendTitle}
        </P>
      ) : null}

      <div className='flex gap-0 flex-wrap justify-center w-full min-w-90 leading-0'>
        <div
          className='h-4 mb-1 w-full min-w-90'
          style={{ background: `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 100%)` }}
        />
        <div className='flex justify-between w-full min-w-90'>
          <P marginBottom='none' size='sm'>
            {numberFormattingFunction(colorDomain[0], undefined, 2, '', '', locale)}
          </P>
          <P marginBottom='none' size='sm'>
            {numberFormattingFunction(colorDomain[1], undefined, 2, '', '', locale)}
          </P>
        </div>
      </div>
    </div>
  );
}
